export const environment = {
  production: true,
  branch: 'produktiv'
  // branch: 'local'
};
